import { v3Api, transformResponse } from './axios'

export const getPhoneRegionRequest = (phone: string, token: string) =>
  transformResponse(
    v3Api.get(`/expert/order/hints/phone-region?phone=${encodeURIComponent(phone)}`, {
      headers: { 'Content-Type': 'application/json', Authorization: `Bearer ${token}` },
    }),
  )
